export const CONVERSAO_PPM_SOPT = 0.029167;

export enum AmostrasScopesEnum {
  ComEnsaiosResultadoAmostraLog = 'ComEnsaiosResultadoAmostraLog',
  ComAmostraLogAmostraUtinga = 'ComAmostraLogAmostraUtinga',
  Info = 'Info',
  Etiqueta = 'Etiqueta',
  Laudo = 'Laudo',
  LaudoPdf = 'LaudoPdf',
  ComLaudos = 'ComLaudos',
}

export enum ViewAmostrasAtuaisScopesEnum {
  ComEnsaiosResultado = 'ComEnsaiosResultado',
}

export enum IdentificacaoOrigemAmostraEnum {
  LOCAL = 'LOCAL',
  SAP = 'SAP',
  SISTEMA = 'SISTEMA',
}

export enum PrefixoAmostraEnum {
  B2B = 'B2B',
  CAR = 'CAR',
  CAT = 'CAT',
  DIV = 'DIV',
  ESC = 'ESC',
  EXP = 'EXP',
  MIN = 'MIN',
  PECA = 'PECA',
  SUC = 'SUC',
}

export enum TipoAmostraEnum {
  CARVAO = 'CARVAO',
  CATALISADOR = 'CATALISADOR',
  ESCORIA = 'ESCORIA',
  MINERIO = 'MINERIO',
  OUTROS = 'OUTROS',
  PLACA = 'PLACA',
}

export enum LocalAmostraLogEnum {
  GUARULHOS = 'GUARULHOS',
  UTINGA = 'UTINGA',
  VILA_GUILHERME = 'VILA_GUILHERME',
}

export enum EtapaAmostraLogEnum {
  ANALISE_LABORATORIO = 'ANALISE_LABORATORIO',
  ANALISE_LABORATORIO_GUARULHOS = 'ANALISE_LABORATORIO_GUARULHOS',
  CADASTRO_COMERCIAL = 'CADASTRO_COMERCIAL',
  CADASTRO_GUARULHOS = 'CADASTRO_GUARULHOS',
  CADASTRO_UTINGA = 'CADASTRO_UTINGA',
  COLETA_LABORATORIO = 'COLETA_LABORATORIO',
  ENVIO_LABORATORIO = 'ENVIO_LABORATORIO',
  ENVIO_LABORATORIO_GUARULHOS = 'ENVIO_LABORATORIO_GUARULHOS',
  FINALIZACAO = 'FINALIZACAO',
  REANALISE = 'REANALISE',
  RECEBIMENTO_LABORATORIO = 'RECEBIMENTO_LABORATORIO',
  RECEBIMENTO_LABORATORIO_GUARULHOS = 'RECEBIMENTO_LABORATORIO_GUARULHOS',
  RECEBIMENTO_PRODUCAO = 'RECEBIMENTO_PRODUCAO',
  SOLICITACAO_ANALISE = 'SOLICITACAO_ANALISE',
}

export enum AmostrasEventsEnum {
  Removida = 'amostras-removidas',
  Criadas = 'amostras-cadastradas',
  AnaliseSolicitada = 'analise-solicitada-amostra',
  EnviadasLaboratorioGuarulhos = 'amostras-enviadas-laboratorio-guarulhos',
  RecebidasLaboratorioGuarulhos = 'amostras-recebidas-laboratorio-guarulhos',
  EnviadasLaboratorio = 'amostras-enviadas-laboratorio-guarulhos',
  RecebidasLaboratorio = 'amostras-recebidas-laboratorio',
  AnaliseIniciada = 'amostra-analise-iniciada',
  Calcinada = 'amostra-calcinada',
  UmidadeRegistrada = 'umidade-registrada',
  Alterada = 'amostra-alterada',
  Finalizada = 'amostra-finalizada',
  AnexoRemovido = 'anexo-removido',
}

export const orderElementos = {
  Au: 1,
  Ag: 2,
  Pt: 3,
  Pd: 4,
  Rh: 5,
  Cu: 6,
  Umidade: Number.POSITIVE_INFINITY,
};

export const englishNameElementos = {
  Au: 'Gold',
  Ag: 'Silver',
  Pt: 'Platinum',
  Pd: 'Palladium',
  Rh: 'Rhodium',
  Cu: 'Copper',
  Umidade: 'Humidity',
};
